<template>
  <v-text-field
    v-model="hookParentChild"
    :rules="emailRules"
    :error-messages="errorMessages"
    :label="$t('email')"
    :prepend-inner-icon="mdiEmailOutline"
    name="email"
    class="body-2"
    placeholder=" "
    outlined
    validate-on-blur
    required
  />
</template>

<script>
import { mdiEmailOutline } from "@mdi/js";
export default {
  name: "EmailField",
  data: vm => ({
    email: "",
    emailRules: [
      v => !!v || vm.$t("field-requied"),
      v => /.+@.+\..+/.test(v) || vm.$t("email-invalid")
    ],
    mdiEmailOutline: mdiEmailOutline
  }),
  computed: {
    errorMessages() {
      return this.$store.state.authentication.error["email"];
    },
    hookParentChild: {
      get() {
        return this.email;
      },
      set(email) {
        this.email = email;
        this.$emit("setFormValue", email);
      }
    }
  }
};
</script>
